import { Injectable } from '@angular/core';
import { RequestOptions, Response, ResponseContentType } from '@angular/http';
import { Booker } from 'app/components/modal/dialog-share-budget/dialog-share-budget.model';
import { FeatureType } from 'app/model/constant';
import { FeatureModel } from 'app/model/user.model';
import { UserShareBudget } from 'app/model/user/user-share-budget';
import { environment } from 'environments/environment';
import * as Cookies from 'js-cookie/src/js.cookie.js';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { ActHttpService, HeaderTypes } from '../act-http/act-http.service';
import { AppConfigService } from '../app-config/app-config.service';
import { UtilitiesService } from '../utilities/utilities.service';
import { CompanyCommunication } from '../../model/user/communication-preference.model';
import { domain } from 'environments/properties';
import { PreApprovalDetail } from 'app/model/checkout/pre-approval.model';

@Injectable()
export class AuthorizeService {

  private shareBudget = new BehaviorSubject<boolean>(null);

  constructor(
    private actHttp: ActHttpService,
    private utilitiesService: UtilitiesService
  ) { }

  shareBudgetCode(code: string, companyId: number, lang: string): Observable<UserShareBudget> {
    const url = environment.endpoint.userShareCode.replace(':code', code) + `?companyId=${companyId}&lang=${lang}`;
    return this.actHttp.get(url, this.actHttp.getRequestOptions(HeaderTypes.ACT_TOKEN))
      .map((res: Response) => res.json().data);
  }

  getCoBookerCookie(): Booker {
    const coBookerCookie = Cookies.get(AppConfigService.coBookerCookieName);

    if (coBookerCookie) {
      return <Booker>JSON.parse(this.utilitiesService.decodeFromCookie(coBookerCookie));
    } else {
      return undefined;
    }
  }

  getShareBudgetCodeCookie(): string {
    return Cookies.get(AppConfigService.shareBudgetCodeCookieName);
  }

  setCoBookerCookie(userId: number, companyId: number, email: string, budget?: number, fullName?: string, expireDate?: number, shareBudgetCode?: string) {
    Cookies.remove(AppConfigService.coBookerCookieName, { domain: domain });
    Cookies.set(AppConfigService.coBookerCookieName, this.utilitiesService.encodeToCookie(JSON.stringify(new Booker(userId, companyId, email, budget, fullName, shareBudgetCode))), { expires: new Date(expireDate), domain: domain });
  }

  setShareBudgetCodeCookie(codeRef: string) {
    Cookies.remove(AppConfigService.shareBudgetCodeCookieName, { domain: domain });
    Cookies.set(AppConfigService.shareBudgetCodeCookieName, codeRef, { expires: 365, domain: domain });
  }

  removeCoBookerCookie() {
    Cookies.remove(AppConfigService.coBookerCookieName, { domain: domain });
    Cookies.remove(AppConfigService.shareBudgetCodeCookieName, { domain: domain });
  }

  setCookieFeatureShareBudgetIsFalse() {
    const featureResult = JSON.parse(this.utilitiesService.decodeFromCookie(Cookies.get(AppConfigService.featureCookieName)));
    const userFeatures = <FeatureModel[]>this.getUserFeatureFromFeature(featureResult);
    if (userFeatures && userFeatures.length > 0) {
      const featuresAllowLimitBudget = userFeatures.find(f => f.feature === FeatureType.ALLOW_SHARE_BUDGET);
      if (featuresAllowLimitBudget) {
        featuresAllowLimitBudget.allow = false;
      }
      Cookies.set(AppConfigService.featureCookieName, this.utilitiesService.encodeToCookie(JSON.stringify(userFeatures)), { expires: 365, domain: domain });
    }
  }

  getUserFeatureFromFeature(features: any[]) {
    const keys = Object.keys(FeatureType).map(key => { return FeatureType[key]; });
    return features.filter(feature => { return keys.indexOf(feature.feature) > -1 });
  }

  setShareBudgetObs(use: boolean) {
    this.shareBudget.next(use);
  }

  getShareBudgetObs(): Observable<any> {
    return this.shareBudget.asObservable();
  }

  getCommunicationPreference(companyId: number, lang: string, isMobile: boolean): Observable<CompanyCommunication> {
    const mode = isMobile ? 'mobile' : 'desktop';
    const url = `${environment.endpoint.companyCommunication}?companyId=${companyId}&lang=${lang}&mode=${mode}`;
    return this.actHttp.get(url, this.actHttp.getRequestOptions(HeaderTypes.ACT_TOKEN))
      .map((res: Response) => res.json().data);
  }

  getCommunicationPreferenceBanner(companyId: number, bannerId: number): Observable<any> {
    const url = `${environment.endpoint.companyCommunicationBanner}?companyId=${companyId}&bannerId=${bannerId}`;
    const requestOptions: RequestOptions = this.actHttp.getRequestOptions(HeaderTypes.ACT_TOKEN);
    requestOptions.responseType = ResponseContentType.ArrayBuffer;
    return this.actHttp.get(url, requestOptions)
      .map((res: Response) => res.arrayBuffer());
  }

  getPreApprovalDetails(approvalRequestId: number): Observable<PreApprovalDetail> {
    const url = `${environment.endpoint.preApprovalDetail.replace(":approvalRequestId", approvalRequestId.toString())}?view=full`;
    return this.actHttp.get(url, this.actHttp.getRequestOptions(HeaderTypes.ACT_TOKEN))
      .map((res: Response) => res.json().data);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/authorize/authorize.service.ts